import { Modal, Toast } from 'shared/ui'
import { GlobalEvents } from 'entities/WebSocket'
import { IdleManager } from 'entities/Auth/ui/IdleManager'
import { PresentationMode } from 'widgets/PresentationMode/ui/PresentationMode'

const OverlayLayout = () => {
  return (
    <>
      <Modal />
      <PresentationMode />
      <Toast />
      <GlobalEvents />
      <IdleManager />
    </>
  )
}

export default OverlayLayout
